import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: true,
        themes: {
            dark: {
                primary: "#7ee8c4",
                secondary: "#07080f",
                accent: "#6ec4e8"
            }
        }
    }
});
